
import React from 'react';
import { useSwiper } from '../hooks/useSwiper';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import TeamBox from './TeamBox';

const TeamSecTwo = ({ className }) => {
    const swiperRef = useSwiper();
    const { t } = useTranslation();

  return (

    <section className={className} id="team-sec" data-bg-src="assets/img/bg/team-bg2-1.png">
        <div className="container">
            <div className="row">
                <div className="col-xl-4">
                    <div className="title-area">
                        <span className="sub-title style2" data-cue="slideInUp">{t('sections.teamSecTwo.sub_title','Our Expert Team')}</span>
                            <h2 className="sec-title" data-cue="slideInUp">{t('sections.teamSecTwo.title','Our Dedicated Team Is Committed To Safeguarding Your Digital Future.')}</h2>
                        <div className="btn-wrap" data-cue="slideInUp">
                            <Link to="/team" className="ot-btn mb-0">{t('sections.teamSecTwo.more_team','More Team')}<i className="far fa-long-arrow-right ms-2"></i></Link>
                    </div>
                </div>
            </div>
            <div className="col-xl-8">
                <div className="slider-area">
                    <div 
                        ref={swiperRef}
                        className="swiper ot-react-slider team-slider2" data-cue="slideInUp" id="teamSlider2" data-slider-options='{"breakpoints":{"0":{"slidesPerView":1},"600":{"slidesPerView":"2"},"768":{"slidesPerView":"3"}}}'
                    >
                        <div className="swiper-wrapper">
                            <TeamBox className="swiper-slide" limit={6} />
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </section>


  );
};

export default TeamSecTwo;